__turbopack_context__.v({
  "img": "styles-module__Mk6NVq__img",
  "imgWrap": "styles-module__Mk6NVq__imgWrap",
  "navigation": "styles-module__Mk6NVq__navigation",
  "slide": "styles-module__Mk6NVq__slide",
  "slider": "styles-module__Mk6NVq__slider",
  "sliderContainer": "styles-module__Mk6NVq__sliderContainer",
});
